// extracted by mini-css-extract-plugin
module.exports = {"outer":"ButtonTab_outer_1DyJ2","small":"ButtonTab_small_3OSLj"};